/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {AuthorRuleFormComponent as ɵc} from './author-rule-form/author-rule-form.component';
export {AuthorRuleComponent as ɵb} from './author-rule.component';
export {declaration as ɵa} from './author-rule.module';
export {AuthorRuleRoutes as ɵd} from './author-rule.routing';